<template>
  <div>
    <div class="handle-box">
      <el-input
        size="small"
        placeholder="输入名称"
        v-model.trim="searchName"
        class="handle-input mr10"
      ></el-input>
      <el-button
        type="primary"
        icon="el-icon-search"
        @click="getData(1)"
        size="small"
        >搜索</el-button
      >
    </div>
    <el-table
      :data="data.records"
      border
      class="table"
      ref="multipleTable"
      header-cell-class-name="table-header"
    >
      <el-table-column header-align="center" prop="project_name" label="标题">
      </el-table-column>
      <el-table-column label="详情" align="center">
        <template #default="scope">
          <el-button size="mini" type="primary" @click="getInfo(scope.row)"
            >产品详情</el-button
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="company_name"
        align="center"
        label="发布者"
      ></el-table-column>

      <el-table-column align="center" label="发布时间" width="180px">
        <template #default="scope">
          {{ $utils.formatDate(scope.row.create_time, "yyyy-MM-dd hh:mm") }}
        </template>
      </el-table-column>

      <el-table-column label="融资类型" align="center" :formatter="type">
      </el-table-column>

      <el-table-column label="融资金额" align="center">
        <template #default="scope">
          {{ scope.row.financing_amount }}万元
        </template>
      </el-table-column>

      <el-table-column label="审核操作" width="180" align="center">
        <template #default="scope">
          <el-button
            type="success"
            size="mini"
            @click="handleEdit(scope.row, 1)"
            >通过</el-button
          >
          <el-button type="danger" size="mini" @click="handleEdit(scope.row, 2)"
            >驳回</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        background
        layout="total, prev, pager, next"
        :current-page="data.current"
        :page-size="20"
        :total="data.total"
        @current-change="getData"
      ></el-pagination>
    </div>

    <!-- 股权详情 -->
    <el-dialog
      title="详情"
      v-model="stock_right_dialog"
      width="1000px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="event_wrap">
        <div class="cover-title">       
          <el-image
            fit="cover"
            class="cover"
            v-if="itemData.companyLogo"
            :src="$utils.fileUrl(itemData.companyLogo)"
            :preview-src-list="[`${$utils.fileUrl(itemData.companyLogo)}`]"
          >
          </el-image>

          <div class="title-name">
            <li>{{ itemData.name }}</li>
            <li>{{ itemData.companyName }}</li>
          </div>
        </div>
        <el-form size="mini" label-position="top" inline>
          <div>
            <el-form-item>{{
              itemData.status === 0 ? "下架" : "上架"
            }}</el-form-item>
          </div>
          <h2>项目信息</h2>
          <div>
            <el-form-item label="公司图集：">
              <div class="atlas">
                <div
                  v-if="itemData.companyPic1"
                  :style="`background-image:url(${$utils.fileUrl(
                    itemData.companyPic1
                  )})`"
                ></div>
                <div
                  v-if="itemData.companyPic2"
                  :style="`background-image:url(${$utils.fileUrl(
                    itemData.companyPic2
                  )})`"
                ></div>
                <div
                  v-if="itemData.companyPic3"
                  :style="`background-image:url(${$utils.fileUrl(
                    itemData.companyPic3
                  )})`"
                ></div>
                <div
                  v-if="itemData.companyPic4"
                  :style="`background-image:url(${$utils.fileUrl(
                    itemData.companyPic4
                  )})`"
                ></div>
              </div>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="公司介绍：">{{
              itemData.companyIntro
            }}</el-form-item>
          </div>
          <div>
            <el-form-item label="项目介绍：">{{
              itemData.projectIntro
            }}</el-form-item>
          </div>
          <h2>团队介绍</h2>
          <div>
            <el-form-item label="创始人介绍：">{{
              itemData.founderIntro
            }}</el-form-item>
          </div>
          <div>
            <el-form-item label="高管介绍：">
              <li>{{ itemData.managerIntro }}</li>
              <li
                :key="index"
                v-for="(item, index) in itemData.stockPersonList"
              >
                {{ item.intro }}
              </li>
            </el-form-item>
          </div>
          <h2>项目亮点</h2>
          <div>
            <el-form-item>
              {{ itemData.projectLightspot }}
            </el-form-item>
          </div>
          <h2>财务数据及预测（单位：万元）</h2>
          <table>
            <tbody>
              <tr>
                <td></td>
                <td :key="item.year" v-for="item in itemData.stockInfoList">
                  {{ item.year }}年
                </td>
              </tr>
              <tr>
                <td>营业收入</td>
                <td
                  :key="item.businessIncome"
                  v-for="item in itemData.stockInfoList"
                >
                  {{ item.businessIncome }}
                </td>
              </tr>
              <tr>
                <td>净利润</td>
                <td
                  :key="item.netProfit"
                  v-for="item in itemData.stockInfoList"
                >
                  {{ item.netProfit }}
                </td>
              </tr>
            </tbody>
          </table>
          <h2>融资计划</h2>
          <div :span="12">
            <el-form-item
              ><span>项目估值：</span> {{ itemData.projectEstimation }}万
            </el-form-item>
          </div>
          <div :span="12">
            <el-form-item
              ><span>融资金额：</span> {{ itemData.financingAmount }}万
            </el-form-item>
          </div>
          <div>
            <el-form-item label="资金用途：">{{
              itemData.usages
            }}</el-form-item>
          </div>
          <h2>融资信息</h2>
          <div>
            <el-form-item>
              <span>附件：</span>
              <el-button
                type="text"
                v-if="itemData.file1"
                @click="$utils.download(itemData.file1, itemData.fileName)"
                size="mini"
                >{{ itemData.fileName }}</el-button
              >
            </el-form-item>
          </div>
        </el-form>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="stock_right_dialog = false"
            >关闭</el-button
          >
        </span>
      </template>
    </el-dialog>
    <!-- 债券详情 -->
    <el-dialog
      title="详情"
      v-model="obligatory_right_dialog"
      width="1000px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="event_wrap">
        <div class="cover-title">
          <div class="title-name">
            <li>项目分类：{{ itemData.type }}</li>
            <li>{{ itemData.companyName }}</li>
          </div>
        </div>
        <el-form size="mini" label-position="top" inline>
          <div>
            <el-form-item>{{
              itemData.status === 0 ? "下架" : "上架"
            }}</el-form-item>
          </div>
          <h2>融资要素</h2>
          <el-row :gutter="40">
            <el-col :span="6">
              <el-form-item>
                <span>融资主体：</span>
                {{ itemData.financingBody }}</el-form-item
              >
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <span>用款主体：</span>
                {{ itemData.disbursementsBody }}</el-form-item
              >
            </el-col>
          </el-row>
          <el-row :gutter="40">
            <el-col :span="6">
              <el-form-item>
                <span>融资金额（万元）：</span>
                {{ itemData.financingAmount }}
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <span>期望利率：</span>
                {{ itemData.aspiredProfit }}%</el-form-item
              >
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <span>用款期限：</span>
                {{ itemData.disbursementsLimit }}
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <span>用款时间：</span>
                {{ itemData.disbursementsTime }}
              </el-form-item>
            </el-col>
          </el-row>
          <div>
            <el-form-item label="融资方式：">{{
              itemData.financingType
            }}</el-form-item>
          </div>
          <div>
            <el-form-item label="标的物：">{{
              itemData.subjectMatter
            }}</el-form-item>
          </div>
          <div>
            <el-form-item label="资金用途：">{{
              itemData.usages
            }}</el-form-item>
          </div>
          <div>
            <el-form-item label="还款来源：">{{
              itemData.repayingSource
            }}</el-form-item>
          </div>
          <div>
            <el-form-item>
              <span>董事会决议：</span>
              {{ itemData.boardResolution === 0 ? "无" : "有" }}
            </el-form-item>
          </div>
          <div>
            <el-form-item label="备注：">
              {{ itemData.remarks }}
            </el-form-item>
          </div>
          <h2>财务数据及预测（单位：万元）</h2>
          <table>
            <tbody>
              <tr>
                <td></td>
                <td :key="item.year" v-for="item in itemData.bondInfoList">
                  {{ item.year }}年
                </td>
              </tr>
              <tr>
                <td>总资产</td>
                <td
                  :key="item.totalAssets"
                  v-for="item in itemData.bondInfoList"
                >
                  {{ item.totalAssets }}
                </td>
              </tr>
              <tr>
                <td>净资产</td>
                <td :key="item.netAssets" v-for="item in itemData.bondInfoList">
                  {{ item.netAssets }}
                </td>
              </tr>
              <tr>
                <td>营业收入</td>
                <td
                  :key="item.businessIncome"
                  v-for="item in itemData.bondInfoList"
                >
                  {{ item.businessIncome }}
                </td>
              </tr>
              <tr>
                <td>净利润</td>
                <td :key="item.netProfit" v-for="item in itemData.bondInfoList">
                  {{ item.netProfit }}
                </td>
              </tr>
            </tbody>
          </table>
          <h2>项目详情</h2>
          <div>
            <el-form-item label="项目名称：">
              {{ itemData.projectName }}
            </el-form-item>
          </div>
          <div>
            <el-form-item label="公司介绍"
              >{{ itemData.companyIntro }}
            </el-form-item>
          </div>
          <div>
            <el-form-item label="项目介绍：">
              {{ itemData.projectIntro }}
            </el-form-item>
          </div>
          <h2>团队介绍</h2>
          <div>
            <el-form-item label="创始人介绍：">
              {{ itemData.founderIntro }}
            </el-form-item>
          </div>
          <div>
            <el-form-item label="高管介绍：">
              <li>{{ itemData.managerIntro }}</li>
              <li :key="index" v-for="(item, index) in itemData.bondPersonList">
                {{ item.intro }}
              </li>
            </el-form-item>
          </div>
          <h2>项目亮点</h2>
          <div>
            <el-form-item>
              {{ itemData.projectLightspot }}
            </el-form-item>
          </div>
          <h2>附件</h2>
          <div>
            <el-form-item>
              <span>附件：</span>
              <el-button
                type="text"
                v-if="itemData.file1"
                @click="$utils.download(itemData.file1, itemData.fileName)"
                size="mini"
                >{{ itemData.fileName }}</el-button
              >
            </el-form-item>
          </div>
        </el-form>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="obligatory_right_dialog = false"
            >关闭</el-button
          >
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {},
      searchName: "",
      itemData: {},
      stock_right_dialog: false,
      obligatory_right_dialog: false,
    };
  },
  methods: {
    async getData(page = 1) {
      if (this.searchName.length > 30) {
        this.$message.warning("搜索内容最多输入30个字");
        return;
      }
      const params = {
        name: this.searchName,
        currentPage: page,
        pageSize: 20,
      };
      try {
        this.$loading.start();
        const res = await this.$api.investment.review.getData(params);
        this.$loading.done();
        if (res.code === 10200) {
          this.data = res.data;
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        this.$loading.done();
      }
    },
    type(data) {
      switch (data.target_type) {
        case 1:
          return "股权投资";
        case 2:
          return "债权投资";
        default:
          return "-";
      }
    },
    handleEdit(data, status) {
      if (!this.loading) {
        const text =
          status === 1 ? "是否确认通过审核？" : "是否确认不通过审核？";
        this.$confirm(text, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            try {
              this.loading = true;
              this.$loading.start();
              const params = {
                targetId: data.target_id,
                targetType: data.target_type,
                auditStatus: status,
              };
              const res = await this.$api.investment.review.setData(params);
              this.loading = false;
              this.$loading.done();
              if (res.code === 10200) {
                this.getData(this.data.current);
                if (status === 1) {
                  this.$message.success("通过成功");
                } else {
                  this.$message.success("驳回成功！");
                }
              } else {
                this.$message.error(res.msg);
              }
            } catch (error) {
              this.loading = false;
              this.$loading.done();
            }
          })
          .catch(() => {});
      }
    },
    async getInfo(data) {
      try {
        this.$loading.start();
        const res = await this.$api.investment.review.getInfo({
          targetType: data.target_type,
          targetId: data.target_id,
        });
        this.$loading.done();
        if (res.code === 10200) {
          this.itemData = res.data;
          if (data.target_type === 1) {
            this.stock_right_dialog = true;
          } else if (data.target_type === 2) {
            this.obligatory_right_dialog = true;
          }
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        this.$loading.done();
      }
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.handle-input {
  width: 200px;
  display: inline-block;
}

.handle-box {
  margin-bottom: 20px;

  .el-select {
    width: 180px;
  }
}

.cover {
  width: 160px;
  height: 90px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}


.event_wrap {
  .cover-title {
    display: flex;

    .cover {
      margin-right: 24px;
    }

    .title-name {
      li {
        line-height: 26px;
      }
    }
  }

  h2 {
    font-size: 1rem;
    font-weight: 500;
    padding: 5px 0;
    color: $--color-primary;
  }

  .atlas {
    display: flex;

    & > div {
      width: 160px;
      height: 90px;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;

      &:not(:last-child) {
        margin-right: 10px;
      }
    }
  }

  table {
    margin: 10px 0;
    td {
      width: 120px;
      height: 36px;
      font-size: 0.875rem;
      text-align: center;
      vertical-align: middle;
      color: $--color-text-regular;
      border: 1px solid $--border-color-base;
    }
  }

  .el-form-item {
    margin-bottom: 0;
    .el-form-item__label {
      padding: 0;
    }
  }

  .remark {
    .title {
      margin: 24px 0;
      padding-left: 10px;
      font-size: 1.125rem;
      border-left: 2px solid #409eff;
    }

    .remark-content {
      font-size: 0.875rem;
      p {
        line-height: 26px;
      }
      img {
        max-width: 100%;
      }
    }
  }
}
</style>